



































































import { library } from '@fortawesome/fontawesome-svg-core';
import { faCode } from '@fortawesome/pro-light-svg-icons';
library.add(faCode);

import BaseTable from '../Common/Mixins/BaseTable.vue';
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  Site,
  DataLoaderParams,
  Subscription,
  Service,
  DeploymentDataLoaderParams,
  Deployment
} from '@/types';
import { deploymentSvc } from '@/services';
import DeployButton from './DeployButton.vue';
import MoreActionsButton from './MoreActionsButton.vue';
import Constants from '@/constants';
import InfoDialog from './InfoDialog.vue';

@Component({
  name: 'deployments-table',
  components: {
    DeployButton,
    MoreActionsButton,
    InfoDialog
  }
})
export default class DeploymentsTable extends mixins(BaseTable) {
  @Prop({ required: true, type: Object })
  service!: Service;

  itemPK: string = 'id';
  sortBy: string = 'created_at';
  dataKey: string = 'deployments';
  withDateRange: boolean = false;

  showCode: boolean = false;
  showInfo: boolean = false;

  currentDeploymentInfo: Deployment | null = null;

  fields: object = {
    app_id: { label: 'APP ID' },
    plan: { label: 'Plan' },
    version: { label: 'Version' },
    cluster: { label: 'Cluster' },
    environment: { label: 'Environment' },
    url: { label: 'Service URL' },
    status: { label: 'Status' },
    action: { label: 'Action' }
  };

  async dataLoader(params: DataLoaderParams): Promise<any> {
    let deploymentParams = { ...params } as DeploymentDataLoaderParams;
    deploymentParams.filters.serviceId = this.service.id;
    return await deploymentSvc.getDeployments(deploymentParams);
  }

  onRowClicked(item: Deployment): void {
    this.currentDeploymentInfo = item;
    this.showInfo = true;
  }

  reset() {
    this.currentPage = 1;

    // @ts-ignore
    this.$refs.table.refresh();
  }
}
